import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "contacts",
      path: "contacts/:query?",
      meta: { icon: "contacts", title: i18n.global.tc("Contact", 100) },
      component: () => import("pages/employee/Contacts"),
    },
  ],

  dialogs: [
    {
      name: "contact-new",
      path: "/contacts/new/:name/:company",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/ContactEdit"),
    },
    {
      name: "contact-edit",
      path: "/contacts/:contactID/edit",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/ContactEdit"),
    },
    {
      name: "contact-view",
      path: "/contacts/:contactID/view/:section",
      meta: { auth: () => store.getters.isEmployee() },
      component: () => import("../../../dialogs/employee/ContactView"),
    },
  ],
};
